export const trackingParams = {
  UTM_SOURCE: 'utm_source',
  UTM_MEDIUM: 'utm_medium',
  UTM_CAMPAIGN: 'utm_campaign',
};

export const OFFER_ROOT = 'offer_root';
